import {z} from "zod"
import {evaluatingTo} from "#graph/nodes/graph/validation"

export const StructDefinition = <StructType extends {[key: string]: unknown}>(structSchema: {[Key in keyof StructType]: z.ZodType<StructType[Key]>}) => ({
    validation: {
        returns: z.object(structSchema),
        parameters: z.object({
            struct: z.object(
                Object.entries(structSchema).reduce((acc, [key, value]) => {
                    return {...acc, [key]: evaluatingTo(value)}
                }, {}),
            ),
        }),
    },
})
